module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "rch2",
      "title": "2. Years of Study (1916–21)"
    }
  }, [_c('p', {
    staticClass: "cn"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044075_Contents#ch2"
    }
  }, [_vm._v("TWO")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagec0"
  }, [_c('img', {
    staticStyle: {
      "width": "6%"
    },
    attrs: {
      "alt": "",
      "src": "images/tit.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044075_Contents#ch2"
    }
  }, [_vm._v("YEARS OF STUDY (1916–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ON THE BRISK AUTUMN EVENING")]), _vm._v(" of September 27, 1916, the steamship "), _c('i', [_vm._v("Botnía")]), _vm._v(" departed from Reykjavík harbor, bound for Copenhagen. Among its passengers were three young musicians whose final destination was Leipzig: Páll Ísólfsson, Jón Leifs, and Sigurður Þórðarson, a violin student four years Leifs’s senior who had also decided to join Ísólfsson on his return to Leipzig and to apply for the conservatory. This was Leifs’s first journey abroad, and it was not without its complications; the trio were delayed for four days in Copenhagen while awaiting a permit to cross the border. Because of the war, they were required to present a signed declaration from the Icelandic consul to establish that they were not suspected of espionage."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn1",
      "id": "rfn1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Their destination had for centuries been one of Germany’s great cultural and commercial capitals. Leipzig University had been founded in 1409, and the city’s musical legacy included the one-time residents J. S. Bach, Schumann, and Mendelssohn—the last of which had founded the city’s conservatory in 1843. The Royal Conservatory of Music of Leipzig, as it was called from 1876, was housed in large, imposing quarters in Grassistraße, south of the city center. Leifs and Ísólfsson rented rooms in a house nearby (Fürstenstraße 11) and obtained both an upright and a grand piano so that they could practice simultaneously."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn2",
      "id": "rfn2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_vm._v("Leifs’s entrance exam took place on October 19. He played a Beethoven sonata but was dissatisfied with the outcome; in a letter to his parents he lamented that his training in Reykjavík had not prepared him adequately for such an ordeal, even though his piano teacher was “among the best there.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn3",
      "id": "rfn3"
    }
  }, [_vm._v("3")])]), _vm._v(" Nevertheless, he was admitted as a piano major. It was his good fortune that enrollment at the conservatory was low due to the war, and Ísólfsson had put in a good word for his friend. He was placed in the studio of one the school’s most highly regarded professors, Robert Teichmüller, from whom Ísólfsson had also taken secondary piano lessons. Leifs developed a closer relationship with Teichmüller than with any of his other teachers, and Teichmüller later became the godfather of his first child. Leifs had nothing but praise for Teichmüller’s pedagogical approach, noting that he “had no method, or to be more precise, had a new method for each and every student.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn4",
      "id": "rfn4"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The conservatory’s curriculum was divided into three levels, according to competence: "), _c('i', [_vm._v("Unter")]), _vm._v("-, "), _c('i', [_vm._v("Mittel")]), _vm._v("- and "), _c('i', [_vm._v("Oberstufe")]), _vm._v(". Leifs was placed in the "), _c('i', [_vm._v("Mittelstufe")]), _vm._v(" but soon began to question whether the jury had overestimated his abilities. Having completed his first lesson, he conveyed Teichmüller’s verdict to his parents: “He said that I was musical but completely lacking in technique, so now I shall only practice technique. Had I begun my studies with him when I was twelve, I would be a good pianist by now.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn5",
      "id": "rfn5"
    }
  }, [_vm._v("5")])]), _vm._v(" Although Leifs practiced diligently, he was at times frustrated by the strict regimen of etudes and scales; he was allowed to proceed to J. S. Bach’s two-part inventions only in early December. At least the effort seemed to be paying off, for at Christmas, Ísólfsson wrote to Leifs’s parents that Teichmüller was “very pleased with him.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn6",
      "id": "rfn6"
    }
  }, [_vm._v("6")])]), _vm._v(" Ísólfsson was himself making splendid progress, and in 1917 he became assistant to his teacher, the renowned organist Karl Straube, at the Thomaskirche.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leifs’s studies abroad proved far costlier than his family had predicted, putting considerable strain on his parents’ household. Tuition cost 360 marks a year, and Leifs had estimated his living expenses at roughly 200 marks a month. But he had little financial self-control and was usually in need of at least 50 additional marks each month, mostly for purchasing clothes or scores. Luckily, Ragnheiður’s business at "), _c('i', [_vm._v("Silkibúðin")]), _vm._v(" was thriving, and Leifs’s parents were able to comply with his frequent requests for more money. Their main concern was that he had enough to eat, since food was in short supply due to the war, but Leifs urged them not to worry. Each day, he and Ísólfsson ate a decent lunch at a cafeteria nearby, but evenings were spent at home with frugal fare: sardines, bread, marmalade, cocoa, and four sugar cubes each."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn7",
      "id": "rfn7"
    }
  }, [_vm._v("7")])]), _vm._v(" Occasionally they would receive butter and sausages from friends in Denmark, and by Christmas 1916 the slight-framed Leifs (his full adult size was five feet eight inches) announced that he had gained a bit of weight and was now 118 pounds. As the war dragged on, though, food rations were reduced, and by December 1917 the city’s restaurants had little to offer beyond mashed turnips."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn8",
      "id": "rfn8"
    }
  }, [_vm._v("8")])]), _vm._v(" Twice that same year, Leifs journeyed by train all the way to Copenhagen for the sole purpose of eating his fill; from there he cheerfully informed his parents that he was consuming “1–2 glasses of cream each day and delicious cakes too.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn9",
      "id": "rfn9"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imaget",
    attrs: {
      "id": "fig2-1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "alt": "Figure 2.1. Leifs (right) and Páll Ísólfsson...",
      "src": "images/fig2-1.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Figure 2.1. Leifs ("), _c('i', [_vm._v("right")]), _vm._v(") and Páll Ísólfsson ("), _c('i', [_vm._v("left")]), _vm._v(") in Leipzig, ca. 1918. From the collection of Þuríður Pálsdóttir.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "title": "32"
    }
  }, [_vm._v("On arriving from humble Reykjavík, Leifs was thoroughly overwhelmed by the splendor of old Europe, which he found “unfamiliar in every way.” Even the towering trees that lined the streets of Leipzig were a new experience, far beyond anything he had seen in his barren homeland:")])]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_vm._v("Everything was alien to me, both daily life and the loftiest art. . . . For the first time in my life I saw streetcars, trains, and countless other things. . . . My first walk through the alleys lined with tall trees was typical: autumn leaves were falling and blowing in the wind. I had never seen anything like it and had never even imagined such a thing. It was equally symbolic when I heard the sound of a symphony orchestra for the first time: Franz Liszt’s "), _c('i', [_vm._v("Faust Symphony")]), _vm._v(". I felt as if I could throw myself on the floor and scream loudly in amazement."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn10",
      "id": "rfn10"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This particular concert took place on October 26, little more than a week after Leifs’s arrival. The renowned Gewandhaus orchestra held its concerts in the New Gewandhaus hall, opened in 1884 and destroyed in World War II. Its principal conductor, and at the helm of the "), _c('i', [_vm._v("Faust Symphony")]), _vm._v(" concert, was the legendary Arthur Nikisch, whose control of the orchestra, as well as his seemingly improvisatory, “gypsy-like” musicianship, mesmerized Leifs."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn11",
      "id": "rfn11"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("For the young Icelander, his initial encounter with the cultural milieu of central Europe was an adventure, but it also had its disadvantages. Even decades later, the more negative aspects of his experience remained lodged in Leifs’s memory: “It seemed to me as if central Europeans were of a different race and I thus became "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }, [_vm._v("quiet and shy, and it took me many years to understand their daily behavior and conduct.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn12",
      "id": "rfn12"
    }
  }, [_vm._v("12")])])])]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_vm._v("Some were not even familiar with the name Iceland, and believed that I was perhaps from Estonia or Ireland or perhaps some island in the Baltic Sea. Some had heard of Icelandic herring that was supposedly better than herring from other countries. Others, more knowledgeable, had heard of Geysir and perhaps also Hekla, but they asked in astonishment: “Iceland! Is it possible? Do humans actually live there?—But you’re not Icelandic, are you?”—Yes, I replied that I was. “But your parents must be Danes or Europeans?” they asked. When I replied in the negative, my interlocutor would sometimes give me a strange look and say: “Well, but at least you are a mix of—an Icelander and a European?” When I also gave a negative reply, the next question came with an awkward glance: “But where in Iceland do the Eskimos live?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn13",
      "id": "rfn13"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Leifs, who had been raised in the spirit of nineteenth-century nationalism, and who was convinced that Iceland was (in his words) “the greatest country in all the world,” found his schoolmates’ ignorance difficult to comprehend. Still, this cultural and physical marginalization of his native land only strengthened his resolve. His vision, later in life, of Iceland assuming a leading role in the world’s culture can be traced not only to his upbringing in a country claiming independence but also to his frustration when confronting a Europe to which his native land hardly seemed to belong.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As a staunch nationalist, Leifs had developed a hatred of Danes and all that reminded him of the old colonial power. In 1917, when Germans banned all foreign correspondence in Icelandic, Leifs chose to write to his family in German rather than Danish, stating that he despised “everything that is Danish. . . . I hate the Danes even more because here everyone thinks that we "), _c('i', [_vm._v("belong")]), _vm._v(" to Denmark (!!!), that we speak Danish (!!!) and that the Old Norse language, which is still spoken in Iceland, is nothing more than a "), _c('i', [_vm._v("dialect")]), _vm._v(" (!!!).”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn14",
      "id": "rfn14"
    }
  }, [_vm._v("14")])]), _vm._v(" A major victory, and one that Leifs fervently desired, was the Act of Union of 1918, which established Iceland as a fully "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }, [_vm._v("sovereign state in personal union with the Danish king. (When this agreement expired twenty-five years later, Denmark was under Nazi occupation, and Icelanders voted in a plebiscite to abandon the union unilaterally in favor of a republic.) A few years later, Leifs expressed in a letter his complete identification with his homeland and the national pride that would—for better or worse—define his lifelong artistic pursuit: “I stand or fall as an Icelander, I can only be understood as an Icelander, for I have always, as long as I remember, loved Iceland more than anything else in this world, almost more than my art or my family.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn15",
      "id": "rfn15"
    }
  }, [_vm._v("15")])])])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ROMANCE AND ILLNESS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("During his student years, Leifs fell in love. Annie Riethof was a fellow Teichmüller student two years Leifs’s senior, born on June 11, 1897 (see "), _c('a', {
    attrs: {
      "href": "#/text/#fig2-2"
    }
  }, [_vm._v("fig. 2.2")]), _vm._v("). Her father, Edwin Riethof, was an affluent businessman from Teplitz (now Teplice) in Bohemia, whose own father, Josef Rindskopf, had established a glass factory there in the 1860s. After Rindskopf’s death, four of his sons, some of who had adopted different last names (Riethof and Rode), founded a new company, Josef Rindskopf’s Söhne A.G., which became one of the leading manufacturers of colorful art nouveau glass objects around the turn of the twentieth century. Edwin married the twenty-three-year-old Gabriele (or Gabi) Perlman in 1894; like him, she was of Jewish descent, from a wealthy merchant’s family in Prague. Theirs was an artistic household. Gabi was a talented pianist in her youth, and Edwin enjoyed singing and painting. Annie’s older sister, Marie, had studied voice at the Leipzig Conservatory, although by the time Leifs came into their lives she had enrolled at the Academy of Visual Arts. Since they were both in Teichmüller’s class, Leifs and Annie must have become acquainted soon after his arrival in Leipzig, but they began their relationship formally on March 23, 1918. To mark their first anniversary a year later, Leifs completed his first original composition, "), _c('i', [_vm._v("Torrek")]), _vm._v(" for piano, with a dedication to Annie (he would later arrange it for orchestra as part of "), _c('i', [_vm._v("Trilogia piccola")]), _vm._v(" op. 1; see "), _c('span', {
    attrs: {
      "href": "#/text/9780253044075_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chap. 3")]), _vm._v("). The title, "), _c('i', [_vm._v("Torrek")]), _vm._v(", already suggests the influence of Old Icelandic literature. The word means “deep sorrow” but is also used to mean “eulogy”; the most famous eulogy found in the ancient sagas—a text that Leifs would later set as op. 33a—is known as "), _c('i', [_vm._v("Sonatorrek")]), _vm._v("—that is, the "), _c('i', [_vm._v("torrek")]), _vm._v(" of the poet’s loss of two sons.")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imaget",
    attrs: {
      "id": "fig2-2"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "title": "35"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "alt": "Figure 2.2. Annie Riethof, ca. 1918....",
      "src": "images/fig2-2.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Figure 2.2. Annie Riethof, ca. 1918. © Leifs Archives, National and University Library, Reykjavík.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We know little of Leifs’s specific musical experiences during his student years, since his letters to his parents, our main source of "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "title": "36"
    }
  }, [_vm._v("information regarding his daily activities, are silent on such matters. However, since Leifs traveled back to Iceland in summer 1918 (his first trip home after arriving in Germany), his correspondence with Ísólfsson reveals that it was the latter’s responsibility to purchase subscription tickets for the two at the Gewandhaus and Alberthalle, a large concert hall at the Leipzig Crystal Palace; it is possible that they subscribed to other seasons as well."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn16",
      "id": "rfn16"
    }
  }, [_vm._v("16")])]), _vm._v(" While Nikisch was no admirer of the avant-garde, his programs provided a steady staple of Austro-German music from Mozart to Bruckner, along with more recent compositions by Mahler and Strauss. The 1918–19 season would have given Leifs the opportunity to hear works such as Beethoven’s symphonies no. 3, 5, 7, and 9, Brahms’s symphonies no. 2 and 4, Bruckner’s Sixth, and excerpts from Wagner’s "), _c('i', [_vm._v("Parsifal")]), _vm._v(" and "), _c('i', [_vm._v("Tristan und Isolde")]), _vm._v(". In light of Leifs’s later development as a composer, it is tempting to speculate whether he also heard Nikisch conduct Strauss’s "), _c('i', [_vm._v("Eine Alpensinfonie")]), _vm._v(" in November 1916, shortly after his arrival in Leipzig, or Mahler’s Sixth Symphony near the end of his residence there, in December 1921."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn17",
      "id": "rfn17"
    }
  }, [_vm._v("17")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In spring 1919 Leifs traveled to Copenhagen to attend the Nordic Music Days—a festival of Scandinavian music that had been held regularly for more than three decades. The Copenhagen festival consisted of eight concerts, and Leifs was able to hear works that were not standard fare in Leipzig’s concert halls. It also prompted his first newspaper article, a festival report for the Icelandic "), _c('i', [_vm._v("Morgunblaðið")]), _vm._v(". He considered Ture Rangström (Symphony no. 1) and Carl Nielsen (Symphony no. 4) to be the most interesting composers presented at the festival, whereas he found Sibelius mediocre at best. His Second Symphony, Leifs declared, contained “hardly any original ideas, and I must consider his work harmless prattle, sometimes pure nonsense.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn18",
      "id": "rfn18"
    }
  }, [_vm._v("18")])]), _vm._v(" Leifs would later form a more sympathetic opinion of Sibelius, whose works he praised in 1957 as being “inspired by landscape and the forces of nature, and humility before them.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn19",
      "id": "rfn19"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Copenhagen festival in 1919 prompted Leifs to consider Iceland’s position in the music world. Though still ruled by the Danish "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "title": "37"
    }
  }, [_vm._v("king, Iceland was now a sovereign nation—yet no Icelandic music had been performed during the festival. Leifs concluded his report by urging his countrymen to raise the level of music culture in Iceland so that the country would not again have to endure such disgrace abroad. The first step, he suggested, would be to found a music school in Reykjavík (which, according to his plans, would eventually become the “Icelandic Conservatory”) and, in conjunction, a performing ensemble that would introduce the masterpieces of the Western canon to local audiences. He also encouraged the forming of a youth choir on the model of Leipzig’s Thomanerchor or Berlin’s cathedral choir, along with a new position for a choral director, who should first be sent to Germany to observe “how the best conductors drill each and every schoolboy, day after day.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn20",
      "id": "rfn20"
    }
  }, [_vm._v("20")])]), _vm._v(" Here Leifs emerges in a role that would become increasingly familiar, as a passionate (though sometimes obstinate) instigator of musical progress in his native land. For the time being, however, his ideas seem to have had little impact at home.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leifs’s main obstacle during his years of study was not his lack of previous training but the feeble state of his health, which prevented him from attending school for long stretches at a time. In spring 1917 he was in severe pain for days, and a doctor suggested it might be heart-related or possibly “chest rheumatism caused by too much practicing.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn21",
      "id": "rfn21"
    }
  }, [_vm._v("21")])]), _vm._v(" His health again turned precarious in 1919. In May he suffered a headache for ten days and nights with no relief, and in September a stay in the Harz mountains, during which he had hoped to recuperate in the country air, came to a regrettable end. He had been there for two weeks when he once again fell seriously ill, and on October 1 he was transported by ambulance to Leipzig, where he spent the next few months in various hospitals and sanatoriums. The diagnosis was pulmonary inflammation, and doctors recommended total rest, thus ruling out the possibility of resuming his studies in the fall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Having graduated from the conservatory in summer 1919, Annie remained in Leipzig for private lessons. She was already giving solo recitals: a program in Teplitz in April 1920 included Mendelssohn’s "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38",
      "title": "38"
    }
  }, [_c('i', [_vm._v("Variations sérieuses")]), _vm._v(", Schubert’s A minor sonata D. 537, Schumann’s "), _c('i', [_vm._v("Kinderszenen")]), _vm._v(", and smaller works by Handel, Reger, and Rachmaninoff. Annie and her mother were a godsend to Leifs in his illness, but Annie’s father opposed her relationship with the young musician. He feared that the couple would move to Iceland (which he saw, rightly, as a dire career choice for a promising pianist), and even if they remained in Germany, the chronically ill Leifs might never be able to provide for his daughter. Leifs, on the other hand, refused even to meet with Riethof, since he found it “impossible to put my trust in someone who values people according to their bourgeois status.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn22",
      "id": "rfn22"
    }
  }, [_vm._v("22")])]), _vm._v(" He had hoped to wed Annie on May 1, 1920—his twenty-first birthday—but now his parents also expressed their reservations, advising him to launch his career before starting a family. In the end, Leifs’s poor health put a halt to their plans. He continued to suffer from pains in the lungs and stomach, and from February 1920 until that summer he received treatment from a Leipzig gastroenterologist who prescribed complete rest."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn23",
      "id": "rfn23"
    }
  }, [_vm._v("23")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When he was well enough to return to the conservatory, Leifs studied piano as well as score reading, orchestration, and theory and also took composition lessons from Paul Graener, who had been appointed as successor to the recently deceased Max Reger. Leifs’s composition notebooks suggest a strict regimen of counterpoint exercises, fugues, and canons, but they also reveal a distinctive musical personality taking shape. Although intended as academic exercises, the two-part inventions he wrote in January 1918 occasionally demonstrate his flair for the dramatic gesture: one culminates in a “Grave” section in which the two parts explode into octaves, marked "), _c('i', [_vm._v("fortissimo")]), _vm._v(" and "), _c('i', [_vm._v("pomposo")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn24",
      "id": "rfn24"
    }
  }, [_vm._v("24")])]), _vm._v(" Another sketchbook, marked “Übungen bei Graener,” contains a string quartet movement on a cantus firmus, the Lutheran chorale "), _c('i', [_vm._v("Ein’ feste Burg ist unser Gott")]), _vm._v("—a tune that Leifs would employ decades later in "), _c('i', [_vm._v("Viking’s Answer")]), _vm._v(" (see "), _c('span', {
    attrs: {
      "href": "#/text/9780253044075_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chap. 9")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leifs also studied orchestration with the Hungarian conductor Aladár Szendrei, making steady progress in the subject. In June 1918, he arranged the "), _c('i', [_vm._v("Adagio sostenuto")]), _vm._v(" from Beethoven’s "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39",
      "title": "39"
    }
  }, [_c('i', [_vm._v("Hammerklavier")]), _vm._v(" sonata for string orchestra, and in 1920 there followed more sonata movements by Beethoven: the slow movements of the "), _c('i', [_vm._v("Pathétique")]), _vm._v(" and op. 26 sonatas arranged for strings and the opening movement of op. 31 no. 3 for winds. His sketchbooks also contain drafts of original works: a dramatic movement for piano titled “In memoriam”—in memory of a gifted young Icelandic pianist, Jón Norðmann, who had succumbed to tuberculosis in Berlin—and another mournful sketch for violin and piano in G minor marked “Andante lamentoso.” Leifs also completed, in October 1920, the first draft (in short score) of a larger work, originally titled "), _c('i', [_vm._v("Symphonische Trilogie")]), _vm._v(", although he later settled on the more modest title of "), _c('i', [_vm._v("Trilogia piccola")]), _vm._v(". It would take him four years to further revise and orchestrate the work, and by then his composing style had taken quite a different direction (see "), _c('span', {
    attrs: {
      "href": "#/text/9780253044075_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chap. 3")]), _vm._v("). Leifs had for a while been attempting to contact the renowned pianist-composer Ferruccio Busoni, hoping that the latter might agree to give him composition lessons, and at their single meeting, in Berlin in autumn 1920, Leifs showed Busoni the first two movements of this work. Busoni remarked that this was interesting and original music but advised him to study Mozart intensively—advice that, according to an account published by Leifs’s friend and colleague, the musicologist Hallgrímur Helgason, somewhat perturbed the young composer."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn25",
      "id": "rfn25"
    }
  }, [_vm._v("25")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By spring 1920, Leifs had missed nearly a year of school because of his illness. It is difficult to gauge whether he used his infirmity as an excuse to devote himself to composition—as Carl-Gunnar Åhlén suggests in his biography—or whether his extended hospital stays led him to reconsider his options for a career in music."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn26",
      "id": "rfn26"
    }
  }, [_vm._v("26")])]), _vm._v(" After his first year at the conservatory he had fretted to his parents about his “nervousness, both when performing and in other things,” and a psychosomatic explanation for his disease does not seem farfetched."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn27",
      "id": "rfn27"
    }
  }, [_vm._v("27")])]), _vm._v(" He had arrived in Leipzig with the hope of becoming a professional pianist, but after three years it seemed clear that he would attain neither the technical skill nor the fluency of a virtuoso. In autumn 1919, having just begun to practice again after months "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40",
      "title": "40"
    }
  }, [_vm._v("away from the instrument, he confessed to his parents that he had felt more incompetent than he could ever have imagined."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn28",
      "id": "rfn28"
    }
  }, [_vm._v("28")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leifs attended the six-week Munich Opera Festival in late summer 1920, and again his report in an Icelandic newspaper gives an indication of his musical tastes. He was particularly impressed with Karl Muck’s conducting of Wagner’s "), _c('i', [_vm._v("Siegfried")]), _vm._v(", less so with Leo Blech and Bruno Walter, both of whom he found to be diligent but dull. He attended Strauss’s "), _c('i', [_vm._v("Die Frau ohne Schatten")]), _vm._v(" (which had premiered earlier that year) and was delighted by the music and the orchestration, although he found the execution less than perfect. In his mind, the highlights of the festival were Franz Schreker’s "), _c('i', [_vm._v("Die Gezeichneten")]), _vm._v(" and Hans Pfitzner’s "), _c('i', [_vm._v("Palestrina")]), _vm._v(", the act I climax of which he described as “burning with conviction.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn29",
      "id": "rfn29"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After yet another health incident in autumn 1920, Leifs finally recommenced his formal studies in spring 1921, after a hiatus of a year and a half. Although still a piano major, he now also took formal conducting lessons with Otto Lohse, director of the Leipzig Stadttheater and a former student of the legendary conductor Hans Richter. Leifs had begun to view conducting as the path most likely to lead to a stable and artistically fulfilling career, and by summer 1921 he had already had his first actual conducting experience, at rehearsals of the Leipzig Philharmonic and the Grotrian-Steinweg orchestra. The latter, intended as a low-price alternative to the Gewandhaus orchestra, operated under the leadership of the maverick conductor Hermann Scherchen. Leifs’s piano teacher Teichmüller had been instrumental in luring Scherchen to Leipzig and presumably introduced him to Leifs, who promptly began taking conducting lessons from him. Scherchen’s anti-Romantic views of the classical repertoire would have a profound influence on Leifs (see "), _c('span', {
    attrs: {
      "href": "#/text/9780253044075_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chap. 3")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn30",
      "id": "rfn30"
    }
  }, [_vm._v("30")])]), _vm._v(" But the experience of conducting an orchestra came at a steep cost, and Leifs’s father had to foot the bill—250 marks for the Philharmonic and 125 for Grotrian-Steinweg. Leifs kept his parents updated on his progress: “And now I know I can conduct an orchestra,” he proudly declared following his debut in May."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn31",
      "id": "rfn31"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imaget",
    attrs: {
      "id": "fig2-3"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_41",
      "title": "41"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "alt": "Figure 2.3. Jón and Annie Leifs in Leipzig, spring...",
      "src": "images/fig2-3.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Figure 2.3. Jón and Annie Leifs in Leipzig, spring 1921. © Photographic Collection, National Museum of Iceland.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leifs graduated from the Leipzig Conservatory on June 17, 1921. It was the fulfillment of a long-held wish, but he must have harbored mixed feelings all the same. In the four years since commencing his studies, he had been repeatedly sidelined by illness, and a career as a pianist seemed unlikely. Leifs’s student records at the conservatory show that his formal education consisted of two and a half years in "), _c('i', [_vm._v("Mittelstufe")]), _vm._v(" (October 1916 to Easter 1919) and only a few months in "), _c('i', [_vm._v("Oberstufe")]), _vm._v(" (from Easter 1921), although he evidently took private lessons from 1919 through 1921 as his health allowed. His graduation recital was not even a full program and, somewhat remarkably, contained not a single solo piece: he performed J. S. Bach’s Concerto in F minor BWV 1056 with a student orchestra and "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_42",
      "title": "42"
    }
  }, [_vm._v("took the piano part in a sonata for violin and piano by Paul Graener, his composition teacher. Still, the concert appears to have been a success. A review in a Leipzig journal, "), _c('i', [_vm._v("Der Drache")]), _vm._v(", praised Leifs’s “admirable understanding of style,” and Teichmüller wrote him a glowing recommendation, stating that he had thoroughly enjoyed teaching “such a talented musician with a personal flair.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn32",
      "id": "rfn32"
    }
  }, [_vm._v("32")])])])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("HONEYMOON IN ICELAND")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A week after his graduation recital, Leifs and Annie Riethof were married. Although his parents had given their consent, Edwin Riethof still objected on the grounds of their uncertain economic future. The newlyweds sailed to Iceland for their honeymoon, arriving on July 22, and Leifs immediately set in motion a plan to invigorate the local music scene in Reykjavík. He hoped to establish a small string ensemble that might later be expanded into a full orchestra, but finding capable players who were willing to take part was a challenge. The previous year, Leifs’s former schoolmate Sigurður Þórðarson had reported to him on the forces available in town: five to six good violinists, three clarinetists, one cellist, two double bassists, two flautists, and a few horn players. Although these were limited resources at best, he encouraged Leifs to go ahead with his plan, declaring it “a scandal” that no such ensemble existed in a town of sixteen thousand inhabitants. Leifs, his friend suggested, should “wake the citizens of Reykjavík from their sleep” and make them appreciate “the ennobling effect that music has on each man’s soul.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn33",
      "id": "rfn33"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The task proved more challenging than Leifs had imagined, not least because Reykjavík’s two leading violinists refused to cooperate. The Dane Paul Bernburg, who had settled in Iceland in 1905 and was a popular performer in the town’s cafés, dismissed Leifs’s strategy as unrealistic, while Þórarinn Guðmundsson, a local violinist and graduate of the Copenhagen Conservatory, had plans for an orchestra of his own. Earlier that summer, he had rehearsed a small ensemble to perform at the Icelandic visit of King Christian X. Seeing potential for further development, Guðmundsson "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_43",
      "title": "43"
    }
  }, [_vm._v("founded The Reykjavík Orchestra ("), _c('i', [_vm._v("Hljómsveit Reykjavíkur")]), _vm._v("), which had roughly twenty members and was the city’s only such regularly performing ensemble until the Iceland Symphony Orchestra was established in 1950. Although Leifs had to make do without the two top players in town, he did convince a group of ten amateurs to form an ensemble that rehearsed four times a week, with the goal of performing a short program at his concert with Annie on September 23. After a rough start, Leifs was heartened by their progress, but he saw no choice but to cancel the entire enterprise when the band’s only violist withdrew. Disillusioned, Leifs explained the project’s failure from his perspective in a newspaper article, stressing his sacrifice of time and talent and taking a rather superior attitude toward the local players: “Without love for my nation and faith in her abilities, my patience would never have carried me this far.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn34",
      "id": "rfn34"
    }
  }, [_vm._v("34")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another of Leifs’s ambitions was to found a music school in Iceland. A short article of his on the subject had already appeared in "), _c('i', [_vm._v("Morgunblaðið")]), _vm._v(" the previous year, but now he laid out his ideas in more detail. He suggested that a music school in Reykjavík could function with a mere three teachers at the outset: a pianist, a violinist, and a cellist. They could form a piano trio and give public concerts, and the group would eventually be expanded to a larger ensemble as more locals acquired the necessary skills. He hoped that a small coterie of well-to-do benefactors might assist in financing the school, alongside other contributions from ordinary music lovers. While many of Leifs’s ideas were commendable, the article’s disdainful tone won him nothing but enemies. For example, he declared that the local church music could “make no man pious” and that most Icelandic compositions were “the skimmed milk of a syrupy Danish music” that he wished had never seen the light of day."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn35",
      "id": "rfn35"
    }
  }, [_vm._v("35")])]), _vm._v(" With his pugnacious attitude, Leifs infuriated virtually all of Reykjavík’s leading musicians, especially Sigfús Einarsson, the cathedral organist, who retorted with an article of his own."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn36",
      "id": "rfn36"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leifs had another tactic for cultivating interest in music among his countrymen. Few books on music had ever been published in Icelandic, and in any case these were long out of print. To address "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_44",
      "title": "44"
    }
  }, [_vm._v("this lack, in summer 1921, Leifs wrote a twenty-eight-page pamphlet on the fundamentals of music, in the hope that this would encourage the locals’ appreciation of the art. The resulting volume, "), _c('i', [_vm._v("Techniques of Music")]), _vm._v(" ("), _c('i', [_vm._v("Tónlistarhættir")]), _vm._v("), was an overly ambitious crash course in music theory, including fugue, double counterpoint, canon, and cantus firmus technique, and it proved too demanding for an amateur readership. The ever ambitious Leifs had the volume printed in Leipzig by the venerable Breitkopf und Härtel press, but sales in Iceland were abysmal, and the proposed second volume never materialized."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn37",
      "id": "rfn37"
    }
  }, [_vm._v("37")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All things considered, Leifs’s 1921 trip to Iceland must be viewed as a failure. He had arrived in Reykjavík with all odds in his favor: he was a homegrown talent with a prestigious conservatory degree, accompanied by his charming and talented wife, yet his prickly personality and ostentatious ideas earned him the animosity of local musicians and adversely affected his future possibilities as an artist there. The only truly successful enterprise of the couple’s honeymoon to Iceland was their concertizing. They gave a two-piano recital at one of the town’s main concert venues, Báran—a wooden house near the lake Tjörnin in central Reykjavík, on the site of what is now Reykjavík’s city hall. On the program were Bach’s F minor Concerto, with Leifs taking the solo part in what had been his graduation piece, Mozart’s Piano Concerto in A major, K. 488 (with Annie as soloist), and Bach’s double harpsichord concerto BWV 1060, in Reger’s arrangement for two pianos. Annie also gave solo recitals in both Báran and the newly constructed Nýja bíó (The new cinema), to great acclaim, with critics lauding her “supple and gentle playing” and “unusually cultivated taste.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn38",
      "id": "rfn38"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("DISCOVERING ICELANDIC FOLK MUSIC")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Even though the journey to Reykjavík was largely a failure, in one respect it proved decisive for Leifs’s future, for it was then that he stumbled on Icelandic folk music as the foundation of his art as a composer. It began with the discovery of a volume on his parents’ "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_45",
      "title": "45"
    }
  }, [_vm._v("bookshelf that had gone more or less unnoticed during his childhood: "), _c('i', [_vm._v("Íslenzk þjóðlög")]), _vm._v(" (Icelandic folk songs), a massive tome of music collected and transcribed by the Icelandic pastor and amateur composer Bjarni Þorsteinsson and published in 1906–09."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn39",
      "id": "rfn39"
    }
  }, [_vm._v("39")])]), _vm._v(" While it may seem odd that Leifs had ignored this collection during his adolescent years, this is most likely explained by the negative perception, common among Icelandic nationalists, of native music as “primitive” and “stagnated” in comparison with the Austro-German tradition that had been Leifs’s staple diet as a piano student. Although he had composed, or at least begun, a handful of pieces during his student years in Leipzig, it was only when he discovered Þorsteinsson’s book that he resolved to try his hand seriously at composition and to employ vernacular tunes as the basis of an Icelandic style. In a newspaper interview in 1959, he reminisced about his internal conflict and uncertainty at this point in his career: “But to compose music . . . no, I didn’t dare. It demanded that I re-live the entire human experience. It demanded everything. But still, I wanted to try. And then I began searching, in an attempt to answer the question whether we in Iceland had some material like other countries, which might be reworked into a new music—some spark that might ignite that big flame.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn40",
      "id": "rfn40"
    }
  }, [_vm._v("40")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The book that provided Leifs with his spark, Þorsteinsson’s "), _c('i', [_vm._v("Íslenzk þjóðlög")]), _vm._v(", is a curious hybrid, and less than half of it consists of folk songs. It is divided into three main sections: transcriptions of music from manuscripts dating from roughly the fourteenth century until around 1800 (pp. 76–408); music from Lutheran hymnals printed in Iceland (pp. 409–520); and over five hundred Icelandic folk songs, transcribed around the turn of the twentieth century by Þorsteinsson himself and a few dozen collaborators in various locations throughout the country (pp. 521–919). Although Þorsteinsson was a beloved amateur composer, he had no systematic training in music. His original compositions are graced with a lyrical gift, though sometimes hampered by a limited harmonic range and predominantly homophonic texture. Þorsteinsson only rarely arranged Icelandic folk songs and never wrote any large-scale "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_46",
      "title": "46"
    }
  }, [_vm._v("works of his own, but he did predict a future in which composers would draw on the vernacular tradition in creating their own styles. In the preface to his collection, he observed that composers in other countries had immersed themselves in “the spirit of folk song, and so can let their new work descend from the fatherland and the nation. In this regard, Icelandic composers of the future have a large task ahead of them.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn41",
      "id": "rfn41"
    }
  }, [_vm._v("41")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In recognizing the value of the native material, Þorsteinsson went against the general viewpoint in Iceland. He found little support for his enterprise among local intellectuals, as is demonstrated by the fact that the Icelandic Literary Society ("), _c('i', [_vm._v("Hið íslenzka bókmenntafélag")]), _vm._v("), at that time virtually the only publisher of scholarly books in Icelandic, rejected his proposal for publication. It was only through a generous grant from the Danish Carlsberg Foundation—established by the founder of the eponymous brewery—that his volume saw the light of day."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn42",
      "id": "rfn42"
    }
  }, [_vm._v("42")])]), _vm._v(" A rare endorsement came from the Danish musicologist Angul Hammerich, who declared Iceland to be a “musical treasure-chest,” echoing claims generally reserved for the country’s literary heritage."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn43",
      "id": "rfn43"
    }
  }, [_vm._v("43")])]), _vm._v(" Another enthusiastic proponent of the native folk song practice was the renowned Icelandic poet Einar Benediktsson, who would soon encourage Leifs on his path to a national music (see "), _c('span', {
    attrs: {
      "href": "#/text/9780253044075_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chap. 3")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leifs made a careful study of Þorsteinsson’s entire tome, as his heavily annotated copy (now part of his collection at the National/University Library in Reykjavík) shows. He was most intrigued by two primary types of nineteenth-century folk music found at the very end of the volume: "), _c('i', [_vm._v("tvísöngur")]), _vm._v(" and "), _c('i', [_vm._v("rímur")]), _vm._v(". In order to better understand Leifs’s musical style, it is necessary to explain the characteristics of each in some detail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Rímur")]), _vm._v(" (rhymes, sing. "), _c('i', [_vm._v("ríma")]), _vm._v(") are a form of epic poetry that appears to have developed in the fourteenth century. A ríma will be in one of various rímur meters ("), _c('i', [_vm._v("rímnahættir")]), _vm._v(") and consists of two to four lines per stanza. Rhyme and alliteration are prevalent features of the genre, as "), _c('a', {
    attrs: {
      "href": "#/text/#ex2-1"
    }
  }, [_vm._v("example 2.1")]), _vm._v(" demonstrates—in a favorite quatrain meter called "), _c('i', [_vm._v("ferskeytt")]), _vm._v(".")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imaget",
    attrs: {
      "id": "ex2-1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_47",
      "title": "47"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "alt": "Example 2.1. Rímur melody...",
      "src": "images/ex2-1.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Example 2.1. Rímur melody (from Leifs, "), _c('i', [_vm._v("25 Icelandic Folk Songs")]), _vm._v(" no. 3).")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('b', [_vm._v("A")]), _vm._v("ndskotann ég "), _c('b', [_vm._v("á")]), _vm._v("ðan "), _c('i', [_vm._v("sá")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("I saw Satan just now")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('b', [_vm._v("u")]), _vm._v("ppi á fjalla "), _c('i', [_vm._v("brúnum")]), _vm._v(",")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("up on the mountain side,")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('b', [_vm._v("h")]), _vm._v("afði "), _c('b', [_vm._v("h")]), _vm._v("att og parruk "), _c('i', [_vm._v("á")]), _vm._v(",")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("he had a hat on and a wig,")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('b', [_vm._v("h")]), _vm._v("ann var að gá að "), _c('i', [_vm._v("kúnum")]), _vm._v(".")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("and was tending the cows.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Here, the first two lines alliterate through vowels (vowels can alliterate with each other: "), _c('i', [_vm._v("a")]), _vm._v("ndskotann/"), _c('i', [_vm._v("á")]), _vm._v("ðan/"), _c('i', [_vm._v("u")]), _vm._v("ppi), while the latter two emphasize "), _c('i', [_vm._v("h")]), _vm._v(" ("), _c('i', [_vm._v("h")]), _vm._v("afði/"), _c('i', [_vm._v("h")]), _vm._v("att/"), _c('i', [_vm._v("h")]), _vm._v("ann). End rhymes (here sá/á; brúnum/kúnum) are characteristic of most quatrains; internal rhymes can also occur in rímur poetry and were considered the mark of a particularly talented versifier. As seen above, another characteristic of many rímur melodies in performance was a kind of mixed meter (often 4–3–4–2) that results from the close alignment of poetic and melodic rhythm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rímur are a kind of Icelandic "), _c('i', [_vm._v("chanson de geste")]), _vm._v("; the oldest surviving such poem is found in "), _c('i', [_vm._v("Flateyjarbók")]), _vm._v(", a manuscript believed to have been copied in the 1390s. Rímur were a mainstay of Icelandic poetry for centuries and were often composed in cycles on an already existing story. "), _c('i', [_vm._v("Núma rímur")]), _vm._v(", for example, relate the story of the Roman king Numa Pompilius while "), _c('i', [_vm._v("Ólafs ríma Haraldssonar")]), _vm._v(" tells the legend of St. Olaf of Norway. Hundreds of rímur cycles have survived—roughly 250 from the eighteenth century and 500 from the nineteenth."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn44",
      "id": "rfn44"
    }
  }, [_vm._v("44")])]), _vm._v(" As late as the nineteenth century, rímur were a mainstay of evening gatherings (known as "), _c('i', [_vm._v("kvöldvaka")]), _vm._v(") on rural farms, where people would gather round to enjoy some kind of recitation. In some cases, rímur singers went from farm to farm, receiving food and accommodation in exchange for their performances."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn45",
      "id": "rfn45"
    }
  }, [_vm._v("45")])]), _vm._v(" In the later nineteenth century, the popularity of rímur diminished sharply, in part due to criticism from a younger generation of Romantic poets who saw it as unworthy of a nation aspiring to independence and requiring a more expressly “cultured” poetry.")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imaget",
    attrs: {
      "id": "ex2-2"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_48",
      "title": "48"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "alt": "Example 2.2. Icelandic tvísöngur...",
      "src": "images/ex2-2.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Example 2.2. Icelandic tvísöngur (Ísland, farsælda frón).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The other main genre of Icelandic folk music was "), _c('i', [_vm._v("tvísöngur")]), _vm._v(" (twin song or two-part song; see "), _c('a', {
    attrs: {
      "href": "#/text/#ex2-2"
    }
  }, [_vm._v("example 2.2")]), _vm._v("). Here, a main tune is doubled at the fifth, with the accompanying voice beginning a fifth below the tune, then converging with the melody at the close of the penultimate phrase and moving to the upper fifth for the conclusion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the preface to his folk song volume, Þorsteinsson was eager to demonstrate the ancient origins of both rímur and tvísöngur genres. Of the latter, he postulated that two-part singing in parallel fifths had, just like the Icelandic language itself, been “brought here by the early settlers; both were first distorted, then disappeared in all of Scandinavia, but both survived, with remarkably few changes, on our remote native land right up to the present day.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn46",
      "id": "rfn46"
    }
  }, [_vm._v("46")])]), _vm._v(" Although tvísöngur is certainly an important Icelandic tradition, the evidence suggests that Þorsteinsson was mistaken in his view of its origin. Practiced in Iceland from at least the thirteenth century, tvísöngur seems to have been an imported tradition of church singing from continental Europe, a kind of note-against-note counterpoint commonly referred to as "), _c('i', [_vm._v("cantus planus binatim")]), _vm._v(" or “doubled "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_49",
      "title": "49"
    }
  }, [_vm._v("plainsong.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn47",
      "id": "rfn47"
    }
  }, [_vm._v("47")])]), _vm._v(" It seems that this tradition was largely—though not exclusively—confined to the two Latin schools, in Skálholt and Hólar. Only in the late eighteenth century, when the schools were temporarily shut down due to a series of devastating natural disasters, was the written tradition of tvísöngur transformed into the orally transmitted (“folk”) one documented in Þorsteinsson’s transcriptions."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn48",
      "id": "rfn48"
    }
  }, [_vm._v("48")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After his epiphany in the summer of 1921, Leifs immersed himself in the Icelandic folk material. Within a few months he had completed new compositions based on folk songs ("), _c('i', [_vm._v("Four Pieces for Piano")]), _vm._v(" op. 2, see "), _c('span', {
    attrs: {
      "href": "#/text/9780253044075_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chap. 3")]), _vm._v(") as well as an article in which he attempted to elucidate “The Character of Icelandic Music” through an analysis of melodies from Þorsteinsson’s collection. It appeared in 1922 in "), _c('i', [_vm._v("Skírnir")]), _vm._v(", a prestigious journal primarily devoted to literature; it is still the oldest continuously published journal in the Nordic countries."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn49",
      "id": "rfn49"
    }
  }, [_vm._v("49")])]), _vm._v(" Here Leifs laid down what he considered the main elements of Icelandic folk music: irregular rhythm, parallel fifths, modal melodies (most frequently Dorian and Lydian) with “missing” notes, narrow ambitus, and recurring motivic patterns. One of Leifs’s remarks on the characteristics of Icelandic vernacular song holds the key to his aesthetic approach during the 1920s. He declared that the scarcity of leading-tone and dominant functions in Icelandic folk songs could be seen as a kind of “free tonality or atonality.” This fit nicely with his own aesthetic preferences and formed the justification for his developing style. Leifs predicted that the new music of the twentieth century, which he noted was “breaking off the shackles of earlier times,” would justify the existence of Icelandic music. Thus, like Bartók, Leifs found elements in his native folk music that he saw pave the way to a musical modernism."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn50",
      "id": "rfn50"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Until Leifs came along, Icelandic composers had largely ignored folk song as a musical influence. For example, the songs of Cathedral organist Sigfús Einarsson are firmly anchored in the nineteenth century, written in a lyrical parlor style with traces of Schumann and Mendelssohn. Einarsson turned his attention to Icelandic folk song only in 1907, when he included four arrangements in a volume of his own "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_50",
      "title": "50"
    }
  }, [_vm._v("songs, and five years later he published another volume that included still more folk song arrangements."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn51",
      "id": "rfn51"
    }
  }, [_vm._v("51")])]), _vm._v(" One of these was "), _c('i', [_vm._v("Ísland, farsælda frón")]), _vm._v(" (see "), _c('a', {
    attrs: {
      "href": "#/text/#ex2-2"
    }
  }, [_vm._v("example 2.2")]), _vm._v("), a well-known tvísöngur to a nationalistic poem by Jónas Hallgrímsson, one of Iceland’s leading nineteenth-century poets (see "), _c('span', {
    attrs: {
      "href": "#/text/9780253044075_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chap. 4")]), _vm._v("). This song had been given pride of place in Þorsteinsson’s collection, where it opens the chapter on tvísöngur and has ever since been cited as the most common and authoritative example of the genre. In its original form "), _c('i', [_vm._v("Ísland, farsælda frón")]), _vm._v(" bears all the hallmarks of the nineteenth-century tvísöngur tradition, but none of these are evident in Einarsson’s arrangement, which was reprinted in 1915 in the popular volume "), _c('i', [_vm._v("Íslenzkt söngvasafn")]), _vm._v(" ("), _c('i', [_vm._v("Icelandic Songbook")]), _vm._v("; see "), _c('a', {
    attrs: {
      "href": "#/text/#ex2-3"
    }
  }, [_vm._v("example 2.3")]), _vm._v("). Here Einarsson focuses on the melody itself, abandoning the parallel fifths in favor of a harmonically conventional setting. His arrangement neatly accommodates most of the melody’s unusual features, but occasionally this results in awkward harmonic progressions—for example, the false relation between B-natural and B-flat in the penultimate measure.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sveinbjörn Sveinbjörnsson, who composed the Icelandic national anthem and was the grand old man of the Reykjavík music scene, took even longer to warm to native folk songs. His volume of "), _c('i', [_vm._v("20 Icelandic Folk Songs")]), _vm._v(" arranged for voice and piano was published in 1924 and was well received; some of the items have never left the repertoire of young Icelandic singers."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn52",
      "id": "rfn52"
    }
  }, [_vm._v("52")])]), _vm._v(" His approach was a decidedly old-fashioned one, as he took great care to make the modal material conform with a tonal harmonic framework. An advertisement for the volume in local newspapers stated that Sveinbjörnsson had “given these old and peculiar Icelandic folk songs a new costume that fits them extremely well, so that many find that they stand equal to the best in this category amongst any other nation.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn53",
      "id": "rfn53"
    }
  }, [_vm._v("53")])]), _vm._v(" In short, the purpose of these arrangements was to clothe the strange and unusual Icelandic melodies in continental garb so that they might be considered equal to—or even be confused with—vernacular tunes of other nations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although these conventional arrangements by Sveinbjörnsson and Einarsson were well received at home, others felt that the moment had arrived for the birth of a truly national style of music. Þorsteinsson’s remark on the “large task” awaiting nationally minded Icelandic composers of the future was quoted above, and in a 1915 lecture on “Iceland and the Scandinavian Influence,” the lexicographer Sigfús Blöndal lamented the Danish influence on local music, claiming that Icelandic folk songs were still “awaiting the arrival of someone like Grieg, who can use them as the basis for compositions that could be profitable to the musical life of the entire world.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn54",
      "id": "rfn54"
    }
  }, [_vm._v("54")])]), _vm._v(" The impact of Danish music on the earlier generation of composers had been considerable, but Leifs took a different path.")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imaget",
    attrs: {
      "id": "ex2-3"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_51",
      "title": "51"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "alt": "Example 2.3. Sigfús Einarsson, arrangement of...",
      "src": "images/ex2-3.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Example 2.3. Sigfús Einarsson, arrangement of "), _c('i', [_vm._v("Ísland, farsælda frón")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leifs often remarked that he did not regard folk music as “true art, but as material for art”—that is, as inspiration. He observed in it the “genial flashes of nationality and nature, a neglected soil, which can be brought to fruition as ‘music of nature.’”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn55",
      "id": "rfn55"
    }
  }, [_vm._v("55")])]), _vm._v(" His goal was to integrate the essential features of Icelandic vernacular music with his own compositional voice. The majority of examples of Leifs’s use of actual folk melodies date from the first eight years of his active composing career, from 1922 to 1930. In the latter year, this phase of his compositional development came to an end with the Organ Concerto op. 7, with its triumphant climax of the old Icelandic chorale "), _c('i', [_vm._v("Allt eins og blómstrið eina")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_52",
      "title": "52"
    }
  }, [_vm._v("As he departed Iceland in autumn 1921, Leifs had discovered an uncommon path to explore as a composer. Since illness had prevented him from fully taking advantage of the Leipzig Conservatory’s curriculum, his opportunities as a professional musician in war-ravaged, economically challenged Germany were limited at best. He would never pursue fame as a pianist but instead attempted to launch a dual (and no less arduous) career as conductor and composer. From then on, Leifs was determined to become Iceland’s first truly national composer, to draw from the country and its songs a kind of music never before imagined.")])]), _vm._v(" "), _c('p', {
    staticClass: "noteh"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "fn1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn1"
    }
  }, [_vm._v("1")]), _vm._v(". Leifs to parents, Copenhagen, October 10, 1916.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "fn2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn2"
    }
  }, [_vm._v("2")]), _vm._v(". “Tónlistarhátíð Norðurlanda,” "), _c('i', [_vm._v("Morgunblaðið")]), _vm._v(", September 19, 1967.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "fn3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn3"
    }
  }, [_vm._v("3")]), _vm._v(". Leifs to parents, Leipzig, November 28, 1916.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "fn4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn4"
    }
  }, [_vm._v("4")]), _vm._v(". Leifs, “Robert Teichmüller †, Erinnerungen eines Auslands-Schülers,” "), _c('i', [_vm._v("Zeitschrift für Musik")]), _vm._v(" 106 (1939): 748–49.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "fn5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn5"
    }
  }, [_vm._v("5")]), _vm._v(". Leifs to parents, Leipzig, October 21 and 24, 1916.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "fn6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn6"
    }
  }, [_vm._v("6")]), _vm._v(". Páll Ísólfsson to Þorleifur Jónsson, December 8, 1916.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "fn7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn7"
    }
  }, [_vm._v("7")]), _vm._v(". Leifs to parents, Leipzig October 18 and 21, 1916.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "fn8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn8"
    }
  }, [_vm._v("8")]), _vm._v(". Leifs to parents, Leipzig, January 1, 1918; Gunnar M. Magnúss, "), _c('i', [_vm._v("Sigurðar bók Þórðarsonar")]), _vm._v(" (Reykjavík: Setberg, 1979), 32; Matthías Johannessen, "), _c('i', [_vm._v("Hundaþúfan og hafið")]), _vm._v(" (Reykjavík: Bókfellsútgáfan, 1961), 130.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "fn9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn9"
    }
  }, [_vm._v("9")]), _vm._v(". Leifs to parents, September 22, 1917.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn10"
    }
  }, [_vm._v("10")]), _vm._v(". Leifs, "), _c('i', [_vm._v("Islands künstlerische Anregung")]), _vm._v(", 19–20.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn11"
    }
  }, [_vm._v("11")]), _vm._v(". Leifs, “Erinnerungen an Karl Muck,” "), _c('i', [_vm._v("Zeitschrift für Musik")]), _vm._v(" 107 (1940): 290.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn12"
    }
  }, [_vm._v("12")]), _vm._v(". Leifs, "), _c('i', [_vm._v("Islands künstlerische Anregung")]), _vm._v(", 19.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn13"
    }
  }, [_vm._v("13")]), _vm._v(". Leifs, “Ísland frá erlendu sjónarmiði,” "), _c('i', [_vm._v("Iðunn")]), _vm._v(" 20 (1937): 49–50.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn14"
    }
  }, [_vm._v("14")]), _vm._v(". Leifs to parents, January 30, 1917.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn15"
    }
  }, [_vm._v("15")]), _vm._v(". Leifs to Rolf Cunz, February 26, 1926.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn16"
    }
  }, [_vm._v("16")]), _vm._v(". Páll Ísólfsson to Leifs, September 30, 1918.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn17"
    }
  }, [_vm._v("17")]), _vm._v(". Johannes Forner, "), _c('i', [_vm._v("Die Gewandhauskonzerte zu Leipzig, 1781–1981")]), _vm._v(" (Leipzig: VEB Deutscher Verlag für Musik, 1981), 441–45.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn18"
    }
  }, [_vm._v("18")]), _vm._v(". Leifs, “Norræn tónlistarhátíð í Kaupm.höfn 13.–21. júní 1919,” "), _c('i', [_vm._v("Morgunblaðið")]), _vm._v(", July 20, 1920.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn19"
    }
  }, [_vm._v("19")]), _vm._v(". See Leifs, “Minning Jean Sibelíusar,” "), _c('i', [_vm._v("Alþýðublaðið")]), _vm._v(", September 24, 1957. The two got along well at a cocktail party at the latter’s country residence, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_53",
      "title": "53"
    }
  }, [_vm._v("Ainola, in 1956, and a year later Leifs attended Sibelius’s funeral on behalf of the Icelandic Composers’ Society.")])]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn20"
    }
  }, [_vm._v("20")]), _vm._v(". Leifs, “Norræn tónlistarhátíð í Kaupm.höfn 13.–21. júní 1919.”")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn21"
    }
  }, [_vm._v("21")]), _vm._v(". Leifs to parents, March 21, 1917.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn22"
    }
  }, [_vm._v("22")]), _vm._v(". Leifs to Edwin Riethof, May 16, 1921.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn23"
    }
  }, [_vm._v("23")]), _vm._v(". Medical note from Dr. Pascal Deuel (Leipzig), July 4, 1920.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn24"
    }
  }, [_vm._v("24")]), _vm._v(". Leifs, Leipzig sketchbooks.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn25"
    }
  }, [_vm._v("25")]), _vm._v(". Hallgrímur Helgason, “Jón Leifs,” in "), _c('i', [_vm._v("Tónskáld og tónmenntir")]), _vm._v(" (Reykjavík: Skákprent, 1993), 109. Helgason suggests that Leifs and Busoni met during Leifs’s twentieth year (i.e., in 1919 or early 1920), but the meeting took place later in 1920, when the opus 1 movements were ready in full score; see Carl-Gunnar Åhlén, "), _c('i', [_vm._v("Jón Leifs—Tónskáld í mótbyr")]), _vm._v(" (Reykjavík: Mál og menning, 1999), 73. Leifs had been attempting to make contact with the composer since 1918. That year, he wrote to the musicologist Hugo Leichtentritt, who sent him Busoni’s address in Zürich (card from Leichtentritt, May 4, 1918), but Leifs appears to have waited until Busoni had returned to Berlin. A letter from Leifs to Busoni, dated October 1, 1920, has survived (Staatsbibliothek zu Berlin, Musikabteilung; Mus.Nachl. F. Busoni B II, 2774+2774a), in which he asks to meet Busoni and also requests lessons from him in composition and orchestration; their meeting presumably took place in October or November that year.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn26"
    }
  }, [_vm._v("26")]), _vm._v(". Åhlén, "), _c('i', [_vm._v("Jón Leifs—Tónskáld í mótbyr")]), _vm._v(", 70.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn27"
    }
  }, [_vm._v("27")]), _vm._v(". Leifs to parents, September 22, 1917. Whatever the cause of Leifs’s illness, it must have seemed to his parents that he might share the fate of his father, who himself had returned to Iceland from Copenhagen without a university degree following an extended ailment (see chap. 1).")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn28"
    }
  }, [_vm._v("28")]), _vm._v(". Þorleifur Jónsson to Leifs, December 11, 1919.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn29"
    }
  }, [_vm._v("29")]), _vm._v(". Leifs, “Söngleikahátíðin í München,” "), _c('i', [_vm._v("Lögrétta")]), _vm._v(", October 20, 1920.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn30"
    }
  }, [_vm._v("30")]), _vm._v(". Hermann Scherchen, "), _c('i', [_vm._v("Werke und Briefe")]), _vm._v(", (Berlin: P. Lang: 1991), 19, 179.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn31"
    }
  }, [_vm._v("31")]), _vm._v(". Leifs to parents, June 1, 1921 (National and University Library, Reykjavík, Lbs 4070 4to).")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn32"
    }
  }, [_vm._v("32")]), _vm._v(". Teichmüller, recommendation for Leifs, June 5, 1921.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn33"
    }
  }, [_vm._v("33")]), _vm._v(". Sigurður Þórðarson to Leifs, August 3, 1920.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn34"
    }
  }, [_vm._v("34")]), _vm._v(". Leifs, “Tónlistarlíf Rvíkur.—Tilraun,” "), _c('i', [_vm._v("Morgunblaðið")]), _vm._v(", September 25, 1921.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn35"
    }
  }, [_vm._v("35")]), _vm._v(". Leifs, “Íslenskt tónlistarlíf,” "), _c('i', [_vm._v("Morgunblaðið")]), _vm._v(", August 14, 1921.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn36"
    }
  }, [_vm._v("36")]), _vm._v(". Sigfús Einarsson, “Örfá orð,” "), _c('i', [_vm._v("Morgunblaðið")]), _vm._v(", September 22, 1921.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn37"
    }
  }, [_vm._v("37")]), _vm._v(". Þorleifur Jónsson to Leifs, May 3, 1923.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn38"
    }
  }, [_vm._v("38")]), _vm._v(". “Hljómleikar,” "), _c('i', [_vm._v("Alþýðublaðið")]), _vm._v(", September 7, 1921; “Hljómleikar,” "), _c('i', [_vm._v("Vísir")]), _vm._v(", October 6, 1921.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn39"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn39"
    }
  }, [_vm._v("39")]), _vm._v(". Þorsteinsson’s volume was—and still is—the definitive collection of Icelandic folk music. Yet it was not the first attempt to collect songs from "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_54",
      "title": "54"
    }
  }, [_vm._v("Iceland. The Frenchman Jean-Benjamin de Laborde had obtained five Icelandic songs for his encyclopedic "), _c('i', [_vm._v("Essai sur la Musique Ancienne et Moderne")]), _vm._v(" (Paris, 1780); the Scottish traveler George Mackenzie included in his book, "), _c('i', [_vm._v("Travels in Iceland, 1810")]), _vm._v(", six “Specimens of the ancient Sacred Music of Iceland.” These transcriptions, and others that appeared in the nineteenth century, are problematic from a scholarly perspective, and although Leifs did make use of one of Laborde’s melodies, it was Þorsteinsson’s collection that gave him the basis for his musical language. For a full account of the circumstances behind the Laborde transcriptions, see Jón Helgason, “Eddasång,” "), _c('i', [_vm._v("Gardar")]), _vm._v(" 3 (1972): 15–49. An Icelandic publication that included several folk song transcriptions was "), _c('i', [_vm._v("Íslenzkar skemtanir")]), _vm._v(" (vol. 2), published in 1888–92. These are also of questionable accuracy, though generally more reliable than the others mentioned here.")])]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn40"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn40"
    }
  }, [_vm._v("40")]), _vm._v(". Matthías Johannessen, “Lögmálin í hrúgunni. Spjallað við Jón Leifs,” "), _c('i', [_vm._v("Morgunblaðið")]), _vm._v(", May 5, 1959.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn41"
    }
  }, [_vm._v("41")]), _vm._v(". Bjarni Þorsteinsson, "), _c('i', [_vm._v("Íslenzk þjóðlög")]), _vm._v(" (Copenhagen: S.L. Møller, 1906–9), 2.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn42"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn42"
    }
  }, [_vm._v("42")]), _vm._v(". Ibid., viii–ix.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn43"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn43"
    }
  }, [_vm._v("43")]), _vm._v(". Angul Hammerich, “Studier over islandsk musik,” "), _c('i', [_vm._v("Aarbøger for nordisk Oldkyndighed og Historie")]), _vm._v(" 14 (1899): 273.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn44"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn44"
    }
  }, [_vm._v("44")]), _vm._v(". Finnur Sigmundsson, "), _c('i', [_vm._v("Rímnatal")]), _vm._v(" (Reykjavík: Rímnafélagið, 1966).")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn45"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn45"
    }
  }, [_vm._v("45")]), _vm._v(". Þorsteinsson, "), _c('i', [_vm._v("Íslenzk þjóðlög")]), _vm._v(", 807.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn46"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn46"
    }
  }, [_vm._v("46")]), _vm._v(". Ibid., 767–68; also published in Bjarni Þorsteinsson, “Íslenzk þjóðlög,” "), _c('i', [_vm._v("Skírnir")]), _vm._v(" 80 (1906): 292.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn47"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn47"
    }
  }, [_vm._v("47")]), _vm._v(". The oldest surviving source for tvísöngur is a two-part "), _c('i', [_vm._v("Credo")]), _vm._v(" and "), _c('i', [_vm._v("Agnus Dei")]), _vm._v(" found in a fragment of a manuscript written in northern Iceland in 1473 (AM 80 b 8vo, in the collection of the Árni Magnússon Institute for Icelandic Studies, Reykjavík).")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn48"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn48"
    }
  }, [_vm._v("48")]), _vm._v(". For a detailed account of the development of tvísöngur, see my doctoral dissertation, “These Are the Things You Never Forget: The Written and Oral Transmission of Icelandic "), _c('i', [_vm._v("Tvísöngur")]), _vm._v("” (PhD diss., Harvard University, 2003).")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn49"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn49"
    }
  }, [_vm._v("49")]), _vm._v(". Leifs, “Íslenskt tónlistareðli,” "), _c('i', [_vm._v("Skírnir")]), _vm._v(" 96 (1922), 130–43. A year later, Leifs translated this article into German, and it was published as “Isländische Volksmusik und germanische Empfindungsart,” "), _c('i', [_vm._v("Die Musik")]), _vm._v(" 16 (1923): 43–52.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn50"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn50"
    }
  }, [_vm._v("50")]), _vm._v(". Leifs, “Íslenskt tónlistareðli,” 141; Leifs, “Isländische Volksmusik,” 46, 51. See also Pamela M. Potter, "), _c('i', [_vm._v("Most German of the Arts")]), _vm._v(": "), _c('i', [_vm._v("Musicology and Society from the Weimar Republic to the End of Hitler’s Reich")]), _vm._v(" (New Haven: Yale University Press, 1998), 217.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn51"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_55",
      "title": "55"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn51"
    }
  }, [_vm._v("51")]), _vm._v(". Sigfús Einarsson, "), _c('i', [_vm._v("Hörpuhljómar")]), _vm._v(" (Reykjavík: Bókaverslun Guðm. Gamalíelssonar, 1907).")])]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn52"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn52"
    }
  }, [_vm._v("52")]), _vm._v(". Sveinbjörnsson also used folk songs in instrumental arrangements, such as "), _c('i', [_vm._v("Vikivaki")]), _vm._v(" (Góða veislu gjöra skal) and "), _c('i', [_vm._v("Islandsk Rhapsodie")]), _vm._v(" (Fagurt galaði fuglinn sá), both of which are undated but probably were written around 1920 and thus postdate Þorsteinsson’s collection. The earliest reference to them in an Icelandic newspaper is in an article about his performance of them in Winnipeg in August 1922 (see “Kveðju-hljómleikar,” "), _c('i', [_vm._v("Heimskringla")]), _vm._v(", August 16, 1922). These two pieces (along with a third one, "), _c('i', [_vm._v("Idyl")]), _vm._v(") were recorded by the composer three years later (see "), _c('i', [_vm._v("Morgunblaðið")]), _vm._v(", September 25, 1925) and were the first instrumental works based on Icelandic folk music to be released on record (Polyphon Musik Z.S.67002).")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn53"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn53"
    }
  }, [_vm._v("53")]), _vm._v(". "), _c('i', [_vm._v("Heimir")]), _vm._v(", January 1, 1924, flyleaf.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn54"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn54"
    }
  }, [_vm._v("54")]), _vm._v(". Sigfús Blöndal, “Ísland og Norðurlönd—Fyrirlestur haldinn á 5. norræna stúdentafundinum á Eiðsvelli 1915,” "), _c('i', [_vm._v("Skírnir")]), _vm._v(" 91 (1917): 149.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "fn55"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn55"
    }
  }, [_vm._v("55")]), _vm._v(". Leifs, “Íslensku þjóðlögin,” "), _c('i', [_vm._v("Vörður")]), _vm._v(", August 29, 1925.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91ef8b24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253044075_Chapter_2.vue
// module id = 90
// module chunks = 0